module.exports = __webpack_public_path__ + "img/evaluation.61e40c63.png";